import type { SearchColumnFilter } from "../../nav/searchNavigationState"
import type { ColumnFilterStateInput } from "./buildServerColumnFilters"

function isNumericFieldType(rawType: unknown): boolean {
  const type = String(rawType || "").toLowerCase().trim()
  if (!type) return false
  const hints = [
    "number",
    "int",
    "integer",
    "float",
    "double",
    "decimal",
    "numeric",
    "currency",
    "money",
    "amount",
    "percent",
    "qty",
    "quantity",
    "count",
    "rating",
    "score",
  ]
  if (hints.some((hint) => type === hint || type.includes(hint))) return true
  const compact = type.replace(/[^a-z0-9]/g, "")
  return hints.some((hint) => compact.includes(hint))
}

/** Merge global-search navigation into column filter state (matching column + typed query). */
export function applySearchColumnFilterToInput(
  filter: SearchColumnFilter,
  fieldTypeByName: Record<string, string>,
  input: ColumnFilterStateInput
): ColumnFilterStateInput | null {
  const field = String(filter.field ?? "").trim()
  const entered = String(filter.value ?? "").trim()
  const exact = String(filter.matchingValue ?? "").trim()
  if (!field || !entered) return null

  const next: ColumnFilterStateInput = {
    text: { ...input.text },
    number: { ...input.number },
    boolean: { ...input.boolean },
    select: { ...input.select },
    created: { ...input.created },
    updated: { ...input.updated },
  }

  if (field === "_form" || field === "_creator" || field === "_itemOwner") {
    next.select[field] = [exact || entered]
    return next
  }

  const type = fieldTypeByName[field] || "text"

  if (type === "select" || type === "dropdown") {
    next.select[field] = [exact || entered]
    return next
  }

  if (type === "relation" || type === "multiplerelation" || type === "systemrelation") {
    next.select[field] = [exact || entered]
    return next
  }

  if (type === "checkbox" || type === "boolean" || type === "bool") {
    const lower = entered.toLowerCase()
    if (lower === "true" || lower === "yes" || lower === "1") {
      next.boolean[field] = "true"
      return next
    }
    if (lower === "false" || lower === "no" || lower === "0") {
      next.boolean[field] = "false"
      return next
    }
    return null
  }

  if (isNumericFieldType(type) || type === "code") {
    next.number[field] = { equals: entered, min: "", max: "" }
    return next
  }

  next.text[field] = entered
  return next
}
